import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../dashboard/_services/data.service';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Filter } from 'src/app/user-management/_model/filter.model';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { GlobalService } from 'src/app/_services/global.service';
import { UploadService } from 'src/app/user-management/_services/upload.service';
import { RoutesService } from 'src/app/buses/_services/routes.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { TranslateService } from '@ngx-translate/core';
import { StaffService } from 'src/app/school-management/_services/staff.service';
import { AmplitudeService } from "src/app/_services/amplitude.service";
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-control-bar',
  templateUrl: './control-bar.component.html',
  styleUrls: ['./control-bar.component.scss']
})

export class ControlBarComponent implements OnInit, OnDestroy {
  filterStatus = false;
  rowsNumberToBeShowed: number;
  items = [25, 50, 100];
  searchSubscription;
  compactView: boolean;
  showDeleteBtn: boolean;
  showMessageBtn: boolean;
  searchInput: string ;
  filterValues: Filter;
  selectedGrades = [];
  selectedGradesCheckBoxes = [];
  selectedClassesCheckBoxes = [];
  selectedRolesCheckBoxes = [];
  selectedGatesCheckBoxes = [];
  selectedGates = [];
  selectedRoutes = [];
  selectedRoutesCheckBoxes = [];
  selectedClasses = [];
  showedClasses = [];
  allGradesIsChecked: boolean;
  allClassesIsChecked: boolean;
  registration: number = -1;
  activation: number = -1;
  roleFilter: Array<any>;
  roles = ['school_admin', 'teacher', 'supervisor', 'security', 'shared_gate_scanner', 'manager'];
  timer = null;
  routes = [];
  gates = [];
  grades = [];
  classes = [];
  currLang;
  @Input() selectedRows;
  @Input() listType;
  @Input() marginToggleViewLeft = false;
  @Output() generateExcel = new EventEmitter<boolean>();
  @Output() printQr = new EventEmitter<boolean>();
  @Output() buttonClicked = new EventEmitter<string>();
  activeTab: string;
  destroy$ = new Subject<void>(); 
  // early dismissal filters
  earlyDismissalType: string | null = null; // 'today' | 'schedule'
  earlyDismissalStatus: string | null = null; // 'parent_arrived' | 'approved' | 'declined' | 'cancelled'
  earlyDismissalCounter: number = 0; // total (existing)
  earlyDismissalDisplayedCount: number = 0; // currently loaded


  constructor(
    private snackBar: SnackbarService,
    private _snackBar: MatSnackBar,
    private qrControl: ControlQrService,
    private uploadService: UploadService,
    private controlDeletion: ControlDeletionService,
    private dataService: DataService,
    private globalService: GlobalService,
    private router: Router,
    private translate: TranslateService,
    private StaffService: StaffService,   
    private messagesControlService: MessagesControlService,
    private amplitudesService: AmplitudeService) {
    this.searchSubscription = new Subscription();
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)control-bar_(f)getLang_(L)82' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit() {
    this.activeTab = window.location.pathname.split('/')[2];
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)control-bar_(f)getLang_(L)91' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    
    this.compactView = false;
    this.showDeleteBtn = true;
    this.showMessageBtn = true;
    this.allGradesIsChecked = false;
    this.allClassesIsChecked = false;
    this.roleFilter = [];
    this.filterValues = new Filter();
    this.filterValues.grades = [];
    this.filterValues.classes = [];
    this.filterValues.roles = [];
    this.filterValues.routes = [];
    this.filterValues.gates = [];
    this.filterValues.registration = -1;

    this.dataService.setRowsStyle(this.compactView)

    this.dataService.getSearchText().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)control-bar_(f)getSearchText_(L)113' , res);      
      this.searchInput = res;
    })

    this.dataService.getRowsNumberShown().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)control-bar_(f)getRowsNumberShown_(L)118' , res);      
      this.rowsNumberToBeShowed = res;
    })

    this.controlDeletion.getDeleteBtnCondition().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)control-bar_(f)getDeleteBtnCondition_(L)123' , res);      

      this.showDeleteBtn = res;
    })

    this.dataService.getFilterStatus().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)control-bar_(f)getFilterStatus_(L)129' , res);      
      this.filterStatus = res;
    })

    // temp .. the enrollment modal is closed
    this.dataService.getFilterFlag().pipe(takeUntil(this.destroy$)).subscribe((res => {
      //console.log('(c)control-bar_(f)getFilterFlag_(L)135' , res);
      if (res === 'close') {
        this.allGradesIsChecked = false;
        this.allClassesIsChecked = false;
        this.roleFilter = [];
        this.filterValues = new Filter();
        this.filterValues.grades = [];
        this.filterValues.classes = [];
        this.filterValues.roles = [];
        this.filterValues.routes = [];
        this.filterValues.gates = [];
        this.filterValues.registration = -1;
        this.dataService.setRowsNumberShown(this.rowsNumberToBeShowed);
        this.dataService.setSearchText(null);
      }
    }))

    this.messagesControlService.getMessageBtnCondition().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)control-bar_(f)getMessageBtnCondition_(L)153' , res);
      this.showMessageBtn = res;
    })

    // subscribe to early dismissal filters
    this.dataService.getEarlyDismissalTypeFilter().pipe(takeUntil(this.destroy$)).subscribe((val) => {
      this.earlyDismissalType = val;
    });
    this.dataService.getEarlyDismissalStatusFilter().pipe(takeUntil(this.destroy$)).subscribe((val) => {
      this.earlyDismissalStatus = val;
    });

    // early dismissal displayed counter subscription
    this.dataService.getEarlyDismissalDisplayedCount().pipe(takeUntil(this.destroy$)).subscribe((count: number) => {
      this.earlyDismissalDisplayedCount = count || 0;
    });

    // this.dataService.getAllGrades$().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
    //   this.grades = res;
    //   this.grades.map(grade => {
    //     this.classes.push(...grade.school_classes)
    //   })
    //   this.dataService.sentGrades(this.grades);
    //   this.dataService.sentClasses(this.classes);
    // })

    this.dataService.getAllGrades()?.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)control-bar_(f)getAllGrades_(L)167' , res);
      this.grades = res;
      this.grades?.map(grade => {
        this.classes.push(...grade.school_classes)
      })
      this.dataService.sentGrades(this.grades);
      this.dataService.sentClasses(this.classes);
    })

    this.dataService.getAllGates()?.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)control-bar_(f)getAllGates_(L)177' , res);
      this.gates = res;
      this.dataService.sentGates(this.gates);
    })

    // this.dataService.getAllRoutes()?.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
    //   this.routes = res.data;
    //   this.dataService.sentRoutes(this.routes)
    // })

    // prevent menu from closing temp
    $('.dropdown-menu.filter-menu').on('click', function (e) {
      e.stopPropagation();
    });
  }

  ngOnDestroy(): void {
    this.dataService.setSearchText(null)
  }


  getSearchIconClass() {
    let searchIconClass = 'search-icon';
    switch (this.listType) {
      case 'bus-tracking':
        searchIconClass = 'search-icon tracking'
        break;
      case 'enroll-bus-students':
        searchIconClass = 'search-icon enroll'
        break;
      case 'available-routes-list':
        searchIconClass = 'search-icon routes'
        break;
      case 'createRoute':
        searchIconClass = 'search-icon createRoute'
        break;

      default:
        break;
    }
    return searchIconClass;
  }

  getRoleName(roleName: string) {
    let newRoleName;
    newRoleName = roleName.includes('_') ? roleName.replace("_", " ") : roleName;
    return newRoleName;
  }

  changeView(compactViewValue: boolean) {
    this.compactView = compactViewValue;
    this.dataService.setRowsStyle(compactViewValue);
  }

  changeRowsNumber(rowsNumber: number) {
    this.rowsNumberToBeShowed = rowsNumber;
    this.dataService.setRowsNumberShown(this.rowsNumberToBeShowed);
  }

  openDeleteModal() {
    let body = { 'noOfShownRows': this.rowsNumberToBeShowed, 'type': this.listType, 'rows_array': this.selectedRows }
    this.controlDeletion.setDeletedRows(body)
    $("#deleteModal").modal("show");
  }

  openPrintModal() {
    switch (this.selectedRows[0].type) {
      case 'parent':
        this.qrControl.setParentsData(this.selectedRows, 'multi');
        $("#qrModal").modal("show");
        break;
        case 'student':
          this.qrControl.setStudentsData(this.selectedRows, 'multi');
          $('#qrStudentModal').modal("show")
          break;
      default:
        break;
    }
    
  }

  sendMessage() {
    let users = this.selectedRows;
    switch (this.listType) {
      case 'students':
        users = users.map(student => {
          return student.users[0]
        });
        break;

      case 'bus-students':
        users = users.map(student => {
          return student.parent_data
        });
        break;
      default:
        break;
    }
    this.messagesControlService.setMessagedRows(users);
    this.router.navigateByUrl('/messages/create-messages');
  }

  clearSearch() {
    this.searchInput = '';
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.dataService.setSearchText(this.searchInput);
      this.globalService.startLoading();
    }, 1400)
  }

  searchHandler() {
    this.amplitudeEventHandler('search');
    // parents and staff are searchable by phone number, so allow a leading '+' on those lists only
    const plusAllowed = this.listType === 'parents' || this.listType === 'staff';
    const regex = `^[\a-zA-z0-9-_${plusAllowed ? '+' : ''}\u0621-\u064A\u0660-\u0669 ]+$`;
    let foundError = this.searchInput.match(regex);
    if (this.searchInput === '' || foundError !== null) {
      // the search input is empty or doesnt has special chars
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.dataService.setSearchText(this.searchInput);
        this.globalService.startLoading();
      }, 1400)
    }
    else {
      this.snackBar.setSnackBarMessage(this.translate.instant('user-management.control-bar.special-warning'));
      this._snackBar.openFromComponent(SnackBarErrorComponent, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    }
  }

  checkAll(filterBy: string) {
    // user select all grades by default we will select all classes   
    if (filterBy === 'grade') {
      this.selectedGrades = this.allGradesIsChecked == true ? [...this.grades] : [];
      this.showedClasses = this.allGradesIsChecked == true ? JSON.parse(JSON.stringify(this.classes)) : [];
      this.selectedClasses = [];
      if (this.selectedGrades.length > 0) {
        this.selectedGrades.map(selectedGrade => {
          this.filterValues.grades.push(selectedGrade.name)
        })
        this.grades.map(grade => {
          grade['isSelected'] = true;
        })
      }
      else {
        // user deselect all grades so by default deslect all classes
        this.allGradesIsChecked = false;
        this.allClassesIsChecked = false;
        this.selectedGrades = [];
        this.selectedClasses = [];
        this.selectedGradesCheckBoxes = [];
        this.selectedClassesCheckBoxes = [];
        this.filterValues.grades = [];
        this.filterValues.classes = [];
      }
    }
    // user selected all classes
    else {
      this.selectedClasses = this.allClassesIsChecked == true ? this.showedClasses : [];
      if (this.selectedClasses.length > 0) {
        this.selectedClasses.map(selectedClass => {
          this.filterValues.classes.push(selectedClass.name)
        })
        this.showedClasses.map(showedClass => {
          showedClass['isSelected'] = true;
        })
      }
      else {
        this.filterValues.classes = [];
      }
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  // check or uncheck from filter
  // grades and classe filter
  filterHandler(filterBy: string, event) {
    // if user filtered by grades
    if (filterBy === 'grade') {
      if (event.checked) {
        this.allClassesIsChecked = this.allClassesIsChecked == true ? false : false;
        this.selectedGrades.push(event.source.value);
        this.selectedGradesCheckBoxes.push(event);
        this.filterValues.grades.push(event.source.value.name);
      }
      else {
        this.selectedGrades = this.selectedGrades.filter(selectedGrade => selectedGrade.id !== event.source.value.id);
        if (this.selectedGrades.length == 0) {
          this.allGradesIsChecked = false;
        }
        this.selectedGradesCheckBoxes = this.selectedGradesCheckBoxes.filter(selectedGradeCb => selectedGradeCb.source.value.id !== event.source.value.id)
        this.selectedClasses = this.selectedClasses.filter(selectedClass => selectedClass.grade_id !== event.source.value.id);
        this.selectedClassesCheckBoxes = this.selectedClassesCheckBoxes.filter(selectedClassCheckBox => selectedClassCheckBox.source.value.grade_id !== event.source.value.id);
        this.filterValues.grades = this.filterValues.grades.filter(grade => grade !== event.source.value.name);
        this.filterValues.classes = [];
        this.selectedClasses.map(selectedClass => {
          this.filterValues.classes.push(selectedClass.name);
        })
      }
      this.updateClasses();
    }
    // if user filtered by class
    if (filterBy === 'class') {
      if (event.checked) {
        this.selectedClasses.push(event.source.value);
        this.selectedClassesCheckBoxes.push(event);
        this.filterValues.classes.push(event.source.value.name);
      }
      else {
        this.selectedClasses = this.selectedClasses.filter(selectedClass => selectedClass.id !== event.source.value.id);
        if (this.selectedClasses.length == 0) {
          // the user unchecked all classes 
          this.allClassesIsChecked = false;
        }
        this.selectedClassesCheckBoxes = this.selectedClassesCheckBoxes.filter(selectedClassCb => selectedClassCb.source.value.id !== event.source.value.id);
        this.filterValues.classes = this.filterValues.classes.filter(oneClass => oneClass !== event.source.value.name);
      }
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  updateClasses() {
    // all classes in selected grade to be shown in filter list
    this.showedClasses = [];
    if (this.selectedGrades.length == 0) {
      this.selectedClasses = [];
      this.filterValues.classes = [];
    }
    else {
      this.selectedGrades.map(grade => {
        this.showedClasses.push(...JSON.parse(JSON.stringify(grade.school_classes)));
      })
      for (let i = 0; i < this.selectedClasses.length; i++) {
        if (this.selectedClasses[i].id === this.showedClasses[i].id) {
          this.showedClasses[i]['isSelected'] = true;
        }
      }
    }
  }

  // refactor if routes names key changed to name only instedd of route_name
  setGateFilter(event) {
    if (event.checked) {
      this.selectedGatesCheckBoxes.push(event);
      this.selectedGates.push(event.source.value);
      this.filterValues.gates.push(event.source.value.name);
    }
    else {
      this.selectedGatesCheckBoxes = this.selectedGatesCheckBoxes.filter(selectedGateCheckBox => selectedGateCheckBox.source.value.id !== event.source.value.id);
      this.selectedGates = this.selectedGates.filter(selectedGate => selectedGate.id !== event.source.value.id);
      this.filterValues.gates = this.filterValues.gates.filter(gate => gate !== event.source.value.name);
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  removeGateFilterFromChips(event) {
    let selectedGateCheckBoxIndex = this.selectedGatesCheckBoxes.findIndex(selectedGateCb => selectedGateCb.source.value.id === event.chip.value.id);
    this.selectedGatesCheckBoxes[selectedGateCheckBoxIndex].source.checked = false;
    this.selectedGatesCheckBoxes = this.selectedGatesCheckBoxes.filter(selectedGateCB => selectedGateCB.source.value.id !== event.chip.value.id);
    this.selectedGates = this.selectedGates.filter(selectedGate => selectedGate.id !== event.chip.value.id)
    this.filterValues.gates = this.filterValues.gates.filter(gate => gate !== event.chip.value.name);
    this.dataService.setFilterValue(this.filterValues);
  }

  setRouteFilter(event) {
    if (event.checked) {
      this.selectedRoutesCheckBoxes.push(event);
      this.selectedRoutes.push(event.source.value);
      this.filterValues.routes.push(event.source.value.route_name);
    }
    else {
      this.selectedRoutesCheckBoxes = this.selectedRoutesCheckBoxes.filter(selectedRouteCheckBox => selectedRouteCheckBox.source.value.id !== event.source.value.id);
      this.selectedRoutes = this.selectedRoutes.filter(selectedRoute => selectedRoute.id !== event.source.value.id);
      this.filterValues.routes = this.filterValues.routes.filter(route => route !== event.source.value.route_name);
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  removeRouteFilterFromChips(event) {
    let selectedRouteCheckBoxIndex = this.selectedRoutesCheckBoxes.findIndex(selectedRouteCb => selectedRouteCb.source.value.id === event.chip.value.id);
    this.selectedRoutesCheckBoxes[selectedRouteCheckBoxIndex].source.checked = false;
    this.selectedRoutesCheckBoxes = this.selectedRoutesCheckBoxes.filter(selectedRouteCB => selectedRouteCB.source.value.name !== event.chip.value.id);
    this.selectedRoutes = this.selectedRoutes.filter(selectedRoute => selectedRoute.id !== event.chip.value.id)
    this.filterValues.routes = this.filterValues.routes.filter(route => route !== event.chip.value.route_name);
    this.dataService.setFilterValue(this.filterValues);
  }

  // roles in staff filter
  setRoleFilter(event) {
    if (event.checked) {
      this.roleFilter.push(event.source.value);
      this.selectedRolesCheckBoxes.push(event);
      this.filterValues.roles.push(event.source.value);
    }
    else {
      this.roleFilter = this.roleFilter.filter(role => role !== event.source.value);
      this.selectedRolesCheckBoxes.filter(selectedRoleCheckBox => selectedRoleCheckBox.source.value.id !== event.source.value.id);
      this.filterValues.roles = this.filterValues.roles.filter(role => role !== event.source.value);
      switch (event.source.value) {
        case 'teacher':
          this.selectedGrades = [];
          this.selectedClasses = [];
          this.selectedClassesCheckBoxes = [];
          this.selectedGradesCheckBoxes = [];
          this.allGradesIsChecked = false;
          this.allClassesIsChecked = false;
          this.filterValues.grades = [];
          this.filterValues.classes = [];
          break;
        case 'security':
        case 'shared_gate_scanner':
          this.selectedGates = [];
          this.selectedGatesCheckBoxes = [];
          this.filterValues.gates = [];
          break;
        case 'supervisor':
          this.selectedGrades = [];
          this.allGradesIsChecked = false;
          this.selectedGradesCheckBoxes = [];
          this.filterValues.grades = [];
          break;
        default:
          break;
      }
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  removeRoleFromChips(event) {
    this.roleFilter = this.roleFilter.filter(role => role !== event.chip._value);
    let selectedRoleCheckBoxIndex = this.selectedRolesCheckBoxes.findIndex(selectedRoleCB => selectedRoleCB.source.value === event.chip.value);
    if (selectedRoleCheckBoxIndex !== -1) {
      this.selectedRolesCheckBoxes[selectedRoleCheckBoxIndex].source.checked = false;
    }
    this.selectedRolesCheckBoxes = this.selectedRolesCheckBoxes.filter(selectedRoleCheckBox => selectedRoleCheckBox.source.value !== event.chip._value);
    this.filterValues.roles = this.filterValues.roles.filter(role => role !== event.chip._value);
    switch (event.chip._value) {
      case 'teacher':
        this.selectedGrades = [];
        this.selectedClasses = [];
        this.allGradesIsChecked = false;
        this.allClassesIsChecked = false;
        this.selectedClassesCheckBoxes = [];
        this.selectedGradesCheckBoxes = [];
        this.filterValues.grades = [];
        this.filterValues.classes = [];
        break;
      case 'security':
      case 'shared_gate_scanner':
        this.selectedGates = [];
        this.selectedGatesCheckBoxes = [];
        this.filterValues.gates = [];
        break;
      case 'supervisor':
        this.selectedGrades = [];
        this.allGradesIsChecked = false;
        this.selectedGradesCheckBoxes = [];
        this.filterValues.grades = [];
        break;
      default:
        break;
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  // gates and routes in staff filters
  toggleRegAndActivationFilters(toggleBy: string, event) {
    if (event.checked) {
      this[toggleBy] = event.source.value;
      this.filterValues[toggleBy] = this[toggleBy];
    }
    else {
      // this code is used also when removed by chips filter 
      this[toggleBy] = -1;
      this.filterValues[toggleBy] = this[toggleBy];
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  // remove by chips component
  removeHandler(removeBy: string, event) {
    if (removeBy === 'grade') {
      this.selectedGrades = this.selectedGrades.filter(selectedGrade => selectedGrade.id !== event.chip.value.id);
      if (this.selectedGrades.length == 0) {
        this.allGradesIsChecked = false;
      }
      let selectedGradeCheckBoxIndex = this.selectedGradesCheckBoxes.findIndex(selectedGradeCB => selectedGradeCB.source.value.id === event.chip.value.id)
      if (selectedGradeCheckBoxIndex !== -1) {
        this.selectedGradesCheckBoxes[selectedGradeCheckBoxIndex].source.checked = false;
      }
      else {
        // the user clicked check all grades btn instead of checking sgrade by grade
        selectedGradeCheckBoxIndex = this.grades.findIndex(grade => grade.id === event.chip.value.id);
        this.grades[selectedGradeCheckBoxIndex].isSelected = false;
      }
      this.selectedClasses = this.selectedClasses.filter(selectedClass => !event.chip.value.school_classes.filter(school_class => school_class.id === selectedClass.id).length);
      this.showedClasses = this.showedClasses.filter(showedClass => !event.chip.value.school_classes.filter(school_class => school_class.id === showedClass.id).length)

      this.filterValues.grades = this.filterValues.grades.filter(grade => grade !== event.chip.value.name);
      this.filterValues.classes = this.filterValues.classes.filter(clazz => !event.chip.value.school_classes.filter(school_class => school_class.name === clazz).length)
    }
    else {
      // remove by class
      this.selectedClasses = this.selectedClasses.filter(selectedClass => selectedClass.id !== event.chip.value.id);
      if (this.selectedClasses.length == 0) {
        // the user unchecked all classes 
        this.allClassesIsChecked = false;
      }
      let selectedClassCheckBoxIndex = this.selectedClassesCheckBoxes.findIndex(selectedClassCB => selectedClassCB.source.value.id === event.chip.value.id)
      if (selectedClassCheckBoxIndex !== -1) {
        // the user choosed the class itself and didnt press all classes        
        this.selectedClassesCheckBoxes[selectedClassCheckBoxIndex].source.checked = false;
      }
      else {
        selectedClassCheckBoxIndex = this.showedClasses.findIndex(oneClass => oneClass.id === event.chip.value.id);
        this.showedClasses[selectedClassCheckBoxIndex].isSelected = false;
      }
      this.filterValues.classes = this.filterValues.classes.filter(oneClass => oneClass !== event.chip.value.name);
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  openAddModal() {
    switch (this.listType) {
      case "students":
        // $("#addStudentModal").modal("show");
        // this.scrollContentTop("#addStudentModal");
        this.onButtonClick('add-student')
        break;
      case "parents":
        // the multi-step Add Parent flow: pick the student, then the guardian
        this.onButtonClick('create-parent')
        break;
      case "staff":
        this.StaffService.setStaffData({}, 'add');
        $("#addStaffModal").modal("show");
        this.amplitudesService.trackEvent('CTA.Add_Staff',{});
        break;
      case "routes":
        this.dataService.setCreateRouteData({});
        break;
      case "grades":
        $("#addGradeModal").modal("show");
        this.amplitudesService.trackEvent('CTA.Add_Grade',{});
        break;
      case "gates":
        $("#addGateModal").modal("show");
        this.scrollContentTop("#addGateModal")
        break;
      case "flows":
        $("#add-flow-popup").modal("show");
        this.amplitudesService.trackEvent('CTA.Add_Flow',{});
        break;
      case "bus-students":
        this.dataService.toggleEnrollStatus(true);
        setTimeout(() => {
          $("#enrollStudents").modal("show");
        this.scrollContentTop("#enrollStudents")
        }, 500);
        this.dataService.setFilterValue(new Filter());
        this.dataService.setFilterFlag('close');
        break;
    }
  }

  regenerateCodes() {
    this.qrControl.setParentsData(this.selectedRows, 'multi');
    $("#confirmModal").modal("show");
  }

  openUpload() {
    this.uploadService.setUploadSectionState(true);
  }

  toggleFilter() {
    this.filterStatus = !this.filterStatus;
    this.dataService.toggleFilterStatus(this.filterStatus);
    this.amplitudeEventHandler('toggleFilter')
  }

  getTipText() {
    let result;
    switch (this.listType) {
      case 'students':
        result = this.translate.instant('user-management.control-bar.add-studet');
        break;
      case 'parents':
        result = this.translate.instant('user-management.control-bar.add-parent');
        break;
      case 'staff':
        result = this.translate.instant('user-management.control-bar.add-staff');
        break;
      case 'grades':
        result = this.translate.instant('user-management.control-bar.add-grade');
        break;
      case 'flows':
        result = this.translate.instant('user-management.control-bar.add-flow');
        break;
      case 'bus-students':
        result = this.translate.instant('user-management.control-bar.enroll-student-buss');
        break;
        case 'gates':
        result = this.translate.instant('user-management.control-bar.add-gate');
        break;
      default:
        break;
    }
    return result;
  }

   // to fix cashed scroll after opening and closing of modal for the same user (add)
   scrollContentTop(modalName){
    $(`${modalName} .modal-body`)[0].scrollTop = 0;
  }

  generateExcelFile(value: boolean) {
    this.globalService.setExportAlert('preparing');
    this.generateExcel.emit(value)
  }

  printQrCodes(value: boolean) {
    let qrObj:any= {}
    qrObj.type = this.listType;
    qrObj.selected = this.selectedRows;
    qrObj.showPrint = value;
    // this.globalService.setExportAlert('preparing');
    this.printQr.emit(qrObj)
  }

  amplitudeEventHandler(event){   
    switch (true) {
      case this.activeTab == 'staff' && event == 'toggleFilter':
        this.amplitudesService.trackEvent('Click.filter_Staff',{});
        break;
        case this.activeTab == 'staff' && event == 'search':
        this.amplitudesService.trackEvent('Click.Search_Staff',{})
        break;
      default:
        break;
    }
  }

  // Early dismissal: chip handlers
  setEarlyDismissalType(type: 'today' | 'schedule') {
    this.dataService.setEarlyDismissalStatusFilter(null);
    this.dataService.setEarlyDismissalTypeFilter(type);
    this.globalService.startLoading();
  }

  setEarlyDismissalParentArrived() {
    this.dataService.setEarlyDismissalTypeFilter(null);
    this.dataService.setEarlyDismissalStatusFilter('parent_arrived');
    this.globalService.startLoading();
  }

  clearEarlyDismissalFilters() {
    this.dataService.setEarlyDismissalTypeFilter('today');
    this.dataService.setEarlyDismissalStatusFilter(null);
    this.globalService.startLoading();
  }

  // Early dismissal: dropdown status selection
  selectEarlyDismissalStatus(status: 'approved' | 'declined' | 'delivered' | 'canceled') {
    this.dataService.setEarlyDismissalTypeFilter(null);
    this.dataService.setEarlyDismissalStatusFilter(status);
    this.globalService.startLoading();
  }

  onButtonClick(action: string): void {
    this.buttonClicked.emit(action);
  }

  goToBulkAdd() {
    switch (this.listType) {
      case 'bus-students':
        this.globalService.setAutoBusEnroll(false);
        this.globalService.setNotifyViewWithBulkEnrollState('not-uploading');
        this.router.navigateByUrl('/buses/bulk-enroll/upload-file');
        break;
      default:
        break;
    }
  }
}